var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9955 1.5C12.5477 1.5 12.9955 1.94772 12.9955 2.5V3.5C12.9955 4.05228 12.5477 4.5 11.9955 4.5C11.4432 4.5 10.9955 4.05228 10.9955 3.5V2.5C10.9955 1.94772 11.4432 1.5 11.9955 1.5Z",
    fill: "#1A1D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9955 19.5C12.5477 19.5 12.9955 19.9477 12.9955 20.5V21.4968C12.9955 22.0491 12.5477 22.4968 11.9955 22.4968C11.4432 22.4968 10.9955 22.0491 10.9955 21.4968V20.5C10.9955 19.9477 11.4432 19.5 11.9955 19.5Z",
    fill: "#1A1D1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49707 11.9984C1.49707 11.4461 1.94479 10.9984 2.49707 10.9984H3.49707C4.04936 10.9984 4.49707 11.4461 4.49707 11.9984C4.49707 12.5507 4.04936 12.9984 3.49707 12.9984H2.49707C1.94479 12.9984 1.49707 12.5507 1.49707 11.9984Z",
    fill: "#1A1D1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4971 11.9984C19.4971 11.4461 19.9448 10.9984 20.4971 10.9984H21.4938C22.0461 10.9984 22.4938 11.4461 22.4938 11.9984C22.4938 12.5507 22.0461 12.9984 21.4938 12.9984H20.4971C19.9448 12.9984 19.4971 12.5507 19.4971 11.9984Z",
    fill: "#1A1D1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57207 19.4219C4.18155 19.0313 4.18155 18.3982 4.57207 18.0077L5.27918 17.3005C5.66971 16.91 6.30287 16.91 6.69339 17.3005C7.08392 17.6911 7.08392 18.3242 6.69339 18.7148L5.98629 19.4219C5.59576 19.8124 4.9626 19.8124 4.57207 19.4219Z",
    fill: "#1A1D1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3 6.69394C16.9095 6.30342 16.9095 5.67025 17.3 5.27973L18.0048 4.5749C18.3953 4.18438 19.0285 4.18438 19.419 4.5749C19.8096 4.96543 19.8096 5.59859 19.419 5.98911L18.7142 6.69394C18.3237 7.08447 17.6905 7.08447 17.3 6.69394Z",
    fill: "#1A1D1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57207 4.5749C4.9626 4.18438 5.59576 4.18438 5.98629 4.5749L6.69339 5.28201C7.08392 5.67253 7.08392 6.3057 6.69339 6.69622C6.30287 7.08675 5.6697 7.08675 5.27918 6.69622L4.57207 5.98911C4.18155 5.59859 4.18155 4.96543 4.57207 4.5749Z",
    fill: "#1A1D1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3 17.3028C17.6905 16.9123 18.3237 16.9123 18.7142 17.3028L19.419 18.0077C19.8096 18.3982 19.8096 19.0313 19.419 19.4219C19.0285 19.8124 18.3953 19.8124 18.0048 19.4219L17.3 18.717C16.9095 18.3265 16.9095 17.6933 17.3 17.3028Z",
    fill: "#1A1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/Light.3e946063c901adef2b3119217584975f.svg";
export { ForwardRef as ReactComponent };